import Plate from '../components/plate/Plate.js';
import Matrix3D from './Matrix3D.js';
import {compareStringsByCodePoints} from '../util/CommonUtils.js';

export default class PlateList {
    /**
     *  @param {string} plateId
     *  @param {InjectionMetaJson[] | InjectionRow[]} injections
     *  @param {Matrix3D} matrix3d
     */
    constructor(plateId, injections, matrix3d) {
        this._meta = Object.assign({plateId: plateId}, matrix3d.meta);
        this._injections = injections;
        /** @type {Map<string, Plate>} */
        this._injectionIdToPlateMap = new Map();
        this._plates = [];
        for (let i = 0; i < matrix3d.meta.maxDepth; i++) {
            let plate = new Plate(matrix3d, i);
            this._plates.push(plate);
            for (const injectionId of plate.getInjectionIds()) {
                this._injectionIdToPlateMap.set(injectionId, plate);
            }
        }
    }

    /** @return {string} */
    get id() {
        return this._meta.plateId;
    }

    /** @return {{plateId: string, rows: number, cols: number, maxDepth: number}} */
    get meta(){
        return this._meta;
    }

    /** @return {InjectionMetaJson[]|InjectionRow[]} */
    get injections() {
        return this._injections;
    }

    /**
     * @param {number} level
     * @return {Plate}
     */
    getPlate(level) {
        return this._plates[level];
    }

    /**
     * @param injectionId
     * @return {{plate: Plate, pos: OnPlatePosition} | null}
     */
    find(injectionId){
        let response = null;
        const plate = this._injectionIdToPlateMap.get(injectionId);
        if (plate) {
            const pos = plate.getCoordinatesByInjectionId(injectionId);
            response = {plate, pos};
        }
        return response
    }

    /**
     * @param {PlateMeta} plateMeta
     * @param {InjectionMetaJson[] | InjectionRow[]} injections
     * @return {PlateList}
     */
    static create(plateMeta, injections) {
        let arr3d = [];
        for (let i = 0; i < plateMeta.rows; i++)
            arr3d[i] = new Array(plateMeta.cols).fill(null);

        for (const injection of injections) {
            const {rowIndex, colIndex} = injection.getOnPlatePosition();
            let cell = arr3d[rowIndex][colIndex];
            if (!cell)
                arr3d[rowIndex][colIndex] = [injection];
            else
                cell.push(injection)
        }

        for (const row of arr3d) {
            for (let i = 0; i < row.length; i++) {
                /**@type {InjectionMetaJson[] | InjectionRow[]}*/
                const cell = row[i];
                if (cell)
                    cell.sort((a, b) => (a.getTimestamp() - b.getTimestamp()) || compareStringsByCodePoints(a.getId(), b.getId()))
            }
        }
        return new PlateList(plateMeta.id, injections, new Matrix3D(arr3d));
    }

    /** @return {Generator<Plate, void, *>} */
    * [Symbol.iterator]() {
        yield* this._plates
    }
}